import { Model, Attr, HasOne } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

@Model()
export default class Payment extends ApplicationRecord {
  static jsonapiType = 'payments';

  static scopeFactory() {
    return Payment.includes([]);
  }

  @Attr() amount: string;
  @Attr() clientSecret: string;

  @HasOne() booking: string;
}
